/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcQuotemediaV1EodPriceJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_QUOTEMEDIA_V1_EOD_PRICE_JOB_STATE_ENTITY_NAME = 'exc.quotemedia.v1.EodPriceJob';
export const excQuotemediaV1EodPriceJobStateEntity = new schema.Entity<ExcQuotemediaV1EodPriceJobState>(EXC_QUOTEMEDIA_V1_EOD_PRICE_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jobId' });

